import React, { useState, useEffect, useRef } from "react";
import { TextField, Button } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Http from "../Http";

export default function BuscarGuia({
  onSelect,
  idCliente = null,
  textoBoton = false,
}) {
  const buttonRef = useRef();
  const [folio, setFolio] = useState("");
  const [mode, setMode] = useState("typing");
  const [folioSeleccionado, setFolioSeleccionado] = useState(null);
  const [opciones, setOpciones] = useState([]);
  let scannedFolio = "";

  const keyDown = (e) => {
    if (e.keyCode === 13 && scannedFolio.length > 0) {
      folioChange({target: { value: scannedFolio } });
      scannedFolio = "";
    } else {
      if (!isNaN(e.key)) {
        scannedFolio = `${scannedFolio}${e.key}`;
      }
    }
  };

  useEffect(() => {
    if (mode === "scanning") {
      window.addEventListener("keydown", keyDown);
    } else {
      window.removeEventListener("keydown", keyDown);
    }
    return () => {
      window.removeEventListener("keydown", keyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  const folioChange = async (event, id_factura) => {
    const value = event ? event.target.value : id_factura;
    setFolio(value);
    let strQuery = ``;
    if (idCliente) {
      strQuery = strQuery + `&id_cliente=${idCliente}`;
    }
    if (id_factura) {
      strQuery = strQuery + `&id_factura=${id_factura}`;
    }
    if (value) {
      strQuery = strQuery + `&folio=${value}`;
    }
    if (value.length > 2) {
      try {
        let Res = await Http.get(`facturas/buscar?${strQuery}`);
        // opciones = Res.data;
        if (mode === "typing") {
          setOpciones(Res.data);
        } else if (mode === "scanning" && Res.data && Res.data.length > 0) {
          setOpciones([]);
          onSelect(Res.data[0]);
        }
        // Vaciar en options y seguir con el proceso
      } catch (error) {
        console.log(error);
      }
    }
  };

  const folioSelecChange = (event, value) => {
    console.log({ value });
    setFolioSeleccionado(value);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    // console.log(folioSeleccionado)
    if (folioSeleccionado) {
      onSelect(folioSeleccionado);
    }
  };

  const changeMode = () => {
    buttonRef.current.blur();
    setMode(mode === "typing" ? "scanning" : "typing");
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div>
        <Button
          variant="text"
          color="primary"
          onClick={changeMode}
          ref={buttonRef}
        >
          Cambiar a modo
          {mode === "typing" ? " Scaneo Codigo de Barras" : " Busqueda Manual"}
        </Button>
      </div>
      {mode === "typing" ? (
        <form
          onSubmit={onSubmit}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Autocomplete
            placeholder={"Buscar por folio"}
            options={opciones}
            getOptionLabel={(option) => option.label}
            style={{ width: 330 }}
            value={folioSeleccionado}
            onChange={folioSelecChange}
            renderInput={(params) => (
              <TextField
                autoFocus={true}
                {...params}
                label="Folio"
                variant="outlined"
                fullWidth
                value={folio}
                onChange={folioChange}
              />
            )}
          />
          <div style={{ margin: 10 }}>
            <Button variant="contained" color="primary" type="submit">
              {textoBoton || "Agregar"}
            </Button>
          </div>
        </form>
      ) : (
        <div> {folio ? `Folio: ${folio}` : "Esperando Lectura"} </div>
      )}
    </div>
  );
}
